import { useState } from "react";
import { Button } from "src/@/components/ui/button";
import { Input } from "src/@/components/ui/input";
import { Card, CardHeader, CardContent, CardFooter } from "src/@/components/ui/card";
import { Textarea } from "src/@/components/ui/textarea";
import useAuth from "src/hooks/useAuth";
// import v2_actionCreateNote from "src/actions/v2/chat/v2_actionCreateNote";

const ChatAddNoteComponent = ({ block, changeBlock }) => {

  return (
    <div className="w-full">
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium">Nota</label>
            <Textarea
               value={block?.data?.chatNoteText}
              className="w-full"
              placeholder="Escreva sua nota aqui..."
              onChange={(e) => {
                let event = {
                  name: "chatNoteText",
                  value: e.target.value
                }
                changeBlock(event)
              }}
            />
          </div>
        </div>
    </div>
  );
};

export default ChatAddNoteComponent;
